// SPDX-License-Identifier: AGPL-3.0-or-later

import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import {CameraPermissionDeniedModal} from '@app/features/voice/components/alerts/CameraPermissionDeniedModal';
import {MicrophonePermissionDeniedModal} from '@app/features/voice/components/alerts/MicrophonePermissionDeniedModal';
import MediaPermission from '@app/features/voice/state/MediaPermission';
import {ensureNativePermission} from '@app/features/voice/utils/NativePermissions';

export type ScreenShareDevicePermissionContext = 'start' | 'replace';

function getCameraDeniedDataFlx(context: ScreenShareDevicePermissionContext): string {
	return context === 'start'
		? 'voice.engine.voice-screen-share-manager.camera-permission-denied-modal'
		: 'voice.engine.voice-screen-share-manager.camera-permission-denied-modal--2';
}

function getMicrophoneDeniedDataFlx(context: ScreenShareDevicePermissionContext): string {
	return context === 'start'
		? 'voice.engine.voice-screen-share-manager.microphone-permission-denied-modal'
		: 'voice.engine.voice-screen-share-manager.microphone-permission-denied-modal--2';
}

export async function ensureNativeCameraPermissionForDeviceShare(
	context: ScreenShareDevicePermissionContext,
): Promise<void> {
	const nativeCameraResult = await ensureNativePermission('camera');
	if (nativeCameraResult === 'denied') {
		MediaPermission.markCameraExplicitlyDenied();
		ModalCommands.push(modal(() => <CameraPermissionDeniedModal data-flx={getCameraDeniedDataFlx(context)} />));
		throw Object.assign(new Error('Camera permission denied'), {name: 'NotAllowedError'});
	}
	if (nativeCameraResult === 'granted') {
		MediaPermission.updateCameraPermissionGranted();
	}
}

export async function ensureNativeMicrophonePermissionForDeviceShare(
	context: ScreenShareDevicePermissionContext,
): Promise<void> {
	const nativeMicrophoneResult = await ensureNativePermission('microphone');
	if (nativeMicrophoneResult === 'denied') {
		MediaPermission.markMicrophoneExplicitlyDenied();
		ModalCommands.push(modal(() => <MicrophonePermissionDeniedModal data-flx={getMicrophoneDeniedDataFlx(context)} />));
		throw Object.assign(new Error('Microphone permission denied'), {name: 'NotAllowedError'});
	}
	if (nativeMicrophoneResult === 'granted') {
		MediaPermission.updateMicrophonePermissionGranted();
	}
}
